import { Tabs } from '@/design-system';
import { ResendSection } from './ResendSection';

export function IntegrationsSection() {
  return <div className="space-y-6">
    <header><h2 className="text-xl font-semibold text-gray-900">Integrações</h2>
      <p className="mt-1 text-sm text-gray-500">Serviços externos conectados à plataforma.</p></header>
    <Tabs label="Integrações" value="resend" onChange={() => undefined}
      tabs={[{ value: 'resend', label: 'Resend', content: <ResendSection /> }]} />
  </div>;
}
